import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Must precede ./auth or ./App imports so the synthetic JWT lands in
// sessionStorage before OidcProvider reads it on first render. No-op in
// production builds (gated by import.meta.env.DEV + VITE_DEV_SKIP_AUTH).
import "./auth/devAuthBypass";
import "./i18n";
import "./styles.css";
import { App } from "./App";
import { loadRuntimeConfig, resolveTenant, tenantLocales } from "./tenants";
import i18n from "./i18n";

async function bootstrap() {
  // Load /config.json (production container writes this from env)
  // before first render. Dev mode 404s — we fall through to
  // import.meta.env.VITE_TENANT.
  await loadRuntimeConfig();
  const tenant = resolveTenant();

  // Seed the locale from the tenant default if the user has no
  // saved preference. The locale switcher and per-user override
  // still take precedence — see src/i18n/index.ts.
  const stored = localStorage.getItem("school_ui_locale");
  const offered: string[] = tenantLocales(tenant);
  if (!stored || !offered.includes(stored)) {
    // No preference, or one this tenant does not offer (a browser that
    // last used a zh-CN site opening the EN/FR demo).
    void i18n.changeLanguage(tenant.defaultLocale);
  }
  for (const [lng, entries] of Object.entries(tenant.stringOverrides ?? {})) {
    for (const [key, value] of Object.entries(entries ?? {})) {
      i18n.addResource(lng, "translation", key, value);
    }
  }
  document.title = tenant.displayName;

  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("#root element not found in index.html");

  createRoot(rootEl).render(
    <StrictMode>
      <App tenant={tenant} />
    </StrictMode>,
  );
}

void bootstrap();
